import pt from '../../locales/pt';
import { DESKTOP_PAGE_HEADER_CLASS } from '../../components/layout/mobileLayoutConstants';
import { AppearanceSettingsCard } from '../../components/settings/AppearanceSettingsCard';

export function Appearance() {
  return (
    <div className="mx-auto max-w-2xl space-y-6 p-4 md:p-8">
      <header className={DESKTOP_PAGE_HEADER_CLASS}>
        <h1 className="text-2xl font-semibold text-foreground">{pt.settings.appearance.title}</h1>
        <p className="mt-1 text-muted-foreground">{pt.settings.appearance.subtitle}</p>
      </header>

      <AppearanceSettingsCard />
    </div>
  );
}
